import React from 'react';
import { connect } from 'react-redux';

import { gettext } from 'utils/text';
import { setFilterKey } from 'ducks/arena';
import { scrollElementIntoViewById } from 'utils/scrollElemntIntoView';

const AddMediaToProject = ({ selectedFilterKey, setFilter }) => (
    <button
        className="btn btn-primary"
        onClick={() => {
            if (selectedFilterKey !== 'my') {
                setFilter('my');
            }
            scrollElementIntoViewById('arena-wrapper', true);
        }}
    >
        {gettext('Add my work')}
    </button>
);

const mapStateToProps = (state) => ({
    selectedFilterKey: state.filterKey,
});

const mapDispatchToProps = (dispatch) => ({
    setFilter: (name) => dispatch(setFilterKey(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMediaToProject);



// WEBPACK FOOTER //
// ./src/components/projects/AddMediaToProject.js